import type { ReactNode } from 'react';

// Copied from facts (components/icons.tsx, v2/icons.tsx, ui/icons.tsx): 16×16 line icons, color — currentColor.

function Icon({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title && <title>{title}</title>}
      {children}
    </svg>
  );
}

export const AlertIcon = ({ title }: { title?: string }) => (
  <Icon title={title}>
    <circle cx="8" cy="8" r="5.6" />
    <path d="M8 5v3.4M8 10.8v.1" />
  </Icon>
);

export const BugIcon = () => (
  <Icon>
    <rect x="4.6" y="5" width="6.8" height="8.6" rx="3.4" />
    <path d="M6 5.2a2 2 0 0 1 4 0M8 8v5.4M4.6 8.6H2.2M13.8 8.6h-2.4M4.8 11.4l-2 1.4M11.2 11.4l2 1.4M4.8 6.2l-1.8-1.4M11.2 6.2 13 4.8" />
  </Icon>
);

export const CameraIcon = () => (
  <Icon>
    <path d="M2 5.6a1 1 0 0 1 1-1h2l1.2-1.8h3.6L11 4.6h2a1 1 0 0 1 1 1v6.6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z" />
    <circle cx="8" cy="8.6" r="2.4" />
  </Icon>
);

export const CheckIcon = ({ title }: { title?: string }) => (
  <Icon title={title}>
    <path d="m3 8.6 3 2.9 7-7" />
  </Icon>
);

export const FileCodeIcon = () => (
  <Icon>
    <path d="M9.4 1.8H4.2a1 1 0 0 0-1 1v10.4a1 1 0 0 0 1 1h7.6a1 1 0 0 0 1-1V5.2z" />
    <path d="M9.4 1.8v3.4h3.4M6.8 8.2 5.4 9.6l1.4 1.4M9.2 8.2l1.4 1.4-1.4 1.4" />
  </Icon>
);

export const FrameIcon = () => (
  <Icon>
    <path d="M2.4 5V3.4a1 1 0 0 1 1-1H5M11 2.4h1.6a1 1 0 0 1 1 1V5M13.6 11v1.6a1 1 0 0 1-1 1H11M5 13.6H3.4a1 1 0 0 1-1-1V11" />
    <rect x="5.4" y="5.4" width="5.2" height="5.2" rx=".6" />
  </Icon>
);

export const ImageIcon = () => (
  <Icon>
    <rect x="2" y="2.8" width="12" height="10.4" rx="1.4" />
    <circle cx="5.8" cy="6.2" r="1.1" />
    <path d="m2.4 12 3.8-3.6 2.6 2.4 1.8-1.6 3 2.8" />
  </Icon>
);

export const InfoIcon = () => (
  <Icon>
    <circle cx="8" cy="8" r="6.2" />
    <path d="M8 7.2v4M8 4.9h.01" />
  </Icon>
);

export const MicIcon = () => (
  <Icon>
    <rect x="6" y="1.8" width="4" height="7.5" rx="2" />
    <path d="M3.6 7.5a4.4 4.4 0 0 0 8.8 0M8 12v2.2M6 14.2h4" />
  </Icon>
);

export const PanelCollapseIcon = () => (
  <Icon>
    <rect x="2" y="2.6" width="12" height="10.8" rx="1.6" />
    <path d="M10 2.6v10.8M5.2 6.2 7 8l-1.8 1.8" />
  </Icon>
);

export const PanelExpandIcon = () => (
  <Icon>
    <rect x="2" y="2.6" width="12" height="10.8" rx="1.6" />
    <path d="M10 2.6v10.8M7 6.2 5.2 8 7 9.8" />
  </Icon>
);

export const PaperclipIcon = () => (
  <Icon>
    <path d="M12.5 7.5 8 12a3 3 0 0 1-4.2-4.2l5-5a2 2 0 0 1 2.9 2.9l-5 5a1 1 0 0 1-1.4-1.4l4.4-4.4" />
  </Icon>
);

export const SendIcon = () => (
  <Icon>
    <path d="M14.2 1.8 7 9M14.2 1.8 9.8 14.2 7.4 8.6 1.8 6.2Z" />
  </Icon>
);

export const ShieldIcon = () => (
  <Icon>
    <path d="M8 1.8 13 3.6v4c0 3-2.1 5.3-5 6.6-2.9-1.3-5-3.6-5-6.6v-4z" />
  </Icon>
);

export const UsersIcon = () => (
  <Icon>
    <circle cx="6" cy="5.5" r="2.3" />
    <path d="M1.8 13.2c.5-2.3 2.2-3.6 4.2-3.6s3.7 1.3 4.2 3.6M10.6 3.4a2.2 2.2 0 0 1 0 4.2M11.8 9.9c1.3.4 2.1 1.6 2.4 3.3" />
  </Icon>
);

export const SparkIcon = () => (
  <Icon>
    <path d="M8 1.8 9.3 6.2 13.7 7.5 9.3 8.8 8 13.2 6.7 8.8 2.3 7.5 6.7 6.2Z" />
    <path d="M13 1.8v2.4M11.8 3h2.4" />
  </Icon>
);

export const StopIcon = () => (
  <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">
    <rect x="4" y="4" width="8" height="8" rx="1.5" fill="currentColor" />
  </svg>
);

export const TraceIcon = () => (
  <Icon>
    <path d="m8.6 7.4 5 1.8-2.2 1-1 2.2z" />
    <path d="M2.4 13.4c1.6-.4 2-1.6 1.6-3s.2-2.6 1.8-3M3 3.2h.01M5.4 2.6h.01" />
  </Icon>
);

export const TrashIcon = () => (
  <Icon>
    <path d="M2.8 4.4h10.4M6.4 4.4V2.8h3.2v1.6M4.4 4.4l.6 8.4a1 1 0 0 0 1 .9h4a1 1 0 0 0 1-.9l.6-8.4" />
  </Icon>
);

export const UndoIcon = () => (
  <Icon>
    <path d="M5.6 3.4 2.6 6.4l3 3" />
    <path d="M2.8 6.4h6.6a3.8 3.8 0 0 1 0 7.6H7" />
  </Icon>
);

export const EyeIcon = () => (
  <Icon>
    <path d="M1.6 8s2.4-4.6 6.4-4.6S14.4 8 14.4 8s-2.4 4.6-6.4 4.6S1.6 8 1.6 8z" />
    <circle cx="8" cy="8" r="2" />
  </Icon>
);

export const RefreshIcon = () => (
  <Icon>
    <path d="M13.6 6.8A5.8 5.8 0 0 0 3.2 5.2M2.4 9.2a5.8 5.8 0 0 0 10.4 1.6" />
    <path d="M13.2 2.6v4.2H9M2.8 13.4V9.2H7" />
  </Icon>
);

export const BackForthIcon = () => (
  <Icon>
    <path d="M2.6 5.4h10.2L10.4 3M13.4 10.6H3.2l2.4 2.4" />
  </Icon>
);

export const ClickIcon = () => (
  <Icon>
    <path d="m5 3 7.4 4.2-3.2.9-1.6 3z" />
    <path d="M3 1.6 3.8 3M1.6 4.4 3 5M6.4 1.4 6 2.8" />
  </Icon>
);

export const ClockIcon = ({ title }: { title?: string }) => (
  <Icon title={title}>
    <circle cx="8" cy="8" r="5.6" />
    <path d="M8 4.8V8l2.2 1.4" />
  </Icon>
);

export const DeadClickIcon = () => (
  <Icon>
    <circle cx="8" cy="8" r="6" />
    <path d="m3.8 3.8 8.4 8.4" />
  </Icon>
);

export const RepeatIcon = () => (
  <Icon>
    <path d="M12.6 6.4A5 5 0 0 0 3.4 6M3.4 9.6a5 5 0 0 0 9.2.4" />
    <path d="M12.8 2.8v3.6H9.2M3.2 13.2V9.6h3.6" />
  </Icon>
);

export const ScreensIcon = () => (
  <Icon>
    <rect x="2" y="3" width="9" height="7" rx="1.2" />
    <path d="M5 13h9V6.4" />
  </Icon>
);

export const ChevronIcon = ({ open }: { open?: boolean }) => (
  <Icon>
    <path d={open ? 'm4 6 4 4 4-4' : 'm6 4 4 4-4 4'} />
  </Icon>
);

export const CloseIcon = () => (
  <Icon>
    <path d="m4 4 8 8M12 4l-8 8" />
  </Icon>
);

export const FlagIcon = () => (
  <Icon>
    <path d="M3.6 14V2.6M3.6 3h7.6l-1.6 2.7 1.6 2.7H3.6" />
  </Icon>
);

export const PlusIcon = () => (
  <Icon>
    <path d="M8 3v10M3 8h10" />
  </Icon>
);

export const KeyIcon = () => (
  <Icon>
    <circle cx="5.5" cy="10.5" r="2.5" />
    <path d="M7.3 8.7L13 3M11 5l2 2" />
  </Icon>
);

export const HourglassIcon = () => (
  <Icon>
    <path d="M4 2h8M4 14h8M5 2c0 3 6 3 6 6s-6 3-6 6M11 2c0 3-6 3-6 6s6 3 6 6" />
  </Icon>
);

export const CropIcon = () => (
  <Icon>
    <path d="M4.5 1.5v9a1 1 0 0 0 1 1h9" />
    <path d="M1.5 4.5h9a1 1 0 0 1 1 1v9" />
  </Icon>
);

/** «[снимок N]» once more in the text: square brackets around a caret line. */
export const MarkIcon = () => (
  <Icon>
    <path d="M5.5 2.5H3.5v11h2M10.5 2.5h2v11h-2" />
    <path d="M8 5.5v5" />
  </Icon>
);

export const ChatIcon = () => (
  <Icon>
    <path d="M2.4 4a1.4 1.4 0 0 1 1.4-1.4h8.4A1.4 1.4 0 0 1 13.6 4v6a1.4 1.4 0 0 1-1.4 1.4H7l-3 2.4v-2.4h-.2A1.4 1.4 0 0 1 2.4 10z" />
    <path d="M5.4 7h.1M8 7h.1M10.6 7h.1" />
  </Icon>
);

export const HelpIcon = () => (
  <Icon>
    <circle cx="8" cy="8" r="6" />
    <path d="M6.3 6.2a1.8 1.8 0 0 1 3.5.6c0 1.2-1.8 1.6-1.8 2.6M8 11.4v.1" />
  </Icon>
);

export const ListIcon = () => (
  <Icon>
    <path d="M5.6 4h7.6M5.6 8h7.6M5.6 12h7.6M2.8 4h.1M2.8 8h.1M2.8 12h.1" />
  </Icon>
);

export const CopyIcon = () => (
  <Icon>
    <rect x="5.4" y="5.4" width="8" height="8" rx="1.2" />
    <path d="M10.6 5.4V3.8a1.2 1.2 0 0 0-1.2-1.2H3.8a1.2 1.2 0 0 0-1.2 1.2v5.6a1.2 1.2 0 0 0 1.2 1.2h1.6" />
  </Icon>
);

export const SearchIcon = () => (
  <Icon>
    <circle cx="7" cy="7" r="4.4" />
    <path d="m10.3 10.3 3.4 3.4" />
  </Icon>
);

export const PinIcon = () => (
  <Icon>
    <path d="M8 14.2s4.4-4 4.4-7.4a4.4 4.4 0 0 0-8.8 0c0 3.4 4.4 7.4 4.4 7.4Z" />
    <circle cx="8" cy="6.8" r="1.5" />
  </Icon>
);

export const ArrowIcon = () => (
  <Icon>
    <path d="M3 8h10M9.4 4.4 13 8l-3.6 3.6" />
  </Icon>
);
